
/*
 *  Manage partner modal dialog
 */
angular.module('qkr').controller('PartnerModalDialogController', ($scope, $uibModal, $uibModalInstance, appConfig,
                                                                  partnerService, gettextCatalog, userAction,
                                                                  partner, businessCategories, messageService) => {

    $scope.userAction = userAction;
    $scope.partner = partner;
    $scope.saving = false;
    $scope.form = {};
    $scope.form.businessCategories = [];
    $scope.form.allowedBusinessCategories = [];

    const init = function() {
        if ($scope.userAction == 'edit') {
            $scope.form.notificationResource = partner.notificationResource;
            $scope.form.allowedCreateMerchant = partner.allowedCreateMerchant;
            $scope.form.isPosType = partner.isPosType;
            $scope.form.RADIO_YES = { label: 'Yes', value: true, checked: partner.allowedCreateMerchant };
            $scope.form.RADIO_NO = { label: 'No', value: false, checked: !partner.allowedCreateMerchant };
            $scope.listBusinessCategories();

        }
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    $scope.updatePartner = function() {
        $scope.updateAllowedBusinessCategory();
        partnerService.update(partner.id, $scope.form.allowedCreateMerchant, $scope.form.allowedBusinessCategories)
            .then((response) => {
                $uibModalInstance.close('done');
            },
            (response) => {
                $uibModalInstance.close('error');
                const modalInstance = $uibModal.open({
                    template: require('../../templates/common/modalPopup.html'),
                    controller: 'CommonModalPopupController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {
                        title() {
                            return gettextCatalog.getString('Unable to update partner');
                        },
                        message() {
                            return response.data.exception;
                        }
                    }
                });

                modalInstance.result.then((result) => {}, () => {});
                $scope.saving = false;
            }
        ).catch(errorPartnerCallBack);
    };

    $scope.listBusinessCategories = function () {
        if (appConfig.isMCAdmin) {
            $scope.form.businessCategories = businessCategories;
            if (partner && partner.allowedBusinessCategories) {
                updateBusinessCategories($scope.form.businessCategories,
                                                partner.allowedBusinessCategories);
            }
        }
    };

    /** Update Business Category list shown on form from list of category and set the ones that should be selected */
    const updateBusinessCategories = function(businessCategories, allowedBusinessCategories) {
        businessCategories.forEach ( category => {
            allowedBusinessCategories.forEach (allowedCategory => {
                if (category.id === parseInt(allowedCategory, 10)) {
                    category.selected = true;
                }
            })
        });
    };

    $scope.updateAllowedBusinessCategory = function() {
        $scope.form.businessCategories.forEach (businessCategory => {
            if (businessCategory.selected) {
                $scope.form.allowedBusinessCategories.push(businessCategory.id)
            }
        });
    };

    const errorPartnerCallBack = function(error) {
        messageService.errorWithReason(error.data.exception, '', true);
    };

    init();
});



// WEBPACK FOOTER //
// ./src/controllers/modal/partner.edit.controller.js